import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import MuiTypography from "@material-ui/core/Typography";
import mapValues from "@core/helper/mapValues";
import getObjectValueByString from "@core/helper/getObjectValueByString";

const variantMapping = {
  "2xl": {
    element: "h1",
    styles: {
      primary: {
        fontSize: 30,
        lineHeight: "120%",
        letterSpacing: "-1px"
      },
      secondary: {
        fontSize: 30,
        lineHeight: "120%",
        letterSpacing: 0
      }
    }
  },
  xl: {
    element: "h2",
    styles: {
      primary: {
        fontSize: 22,
        lineHeight: "120%",
        letterSpacing: "-1px"
      },
      secondary: {
        fontSize: 22,
        lineHeight: "120%",
        letterSpacing: 0
      }
    }
  },
  lg: {
    element: "h3",
    styles: {
      primary: {
        fontSize: 20,
        lineHeight: "120%",
        letterSpacing: "-0.75px"
      },
      secondary: {
        fontSize: 20,
        lineHeight: "120%",
        letterSpacing: 0
      }
    }
  },
  md: {
    element: "h4",
    styles: {
      primary: {
        fontSize: 18,
        lineHeight: "130%",
        letterSpacing: "-0.5px"
      },
      secondary: {
        fontSize: 18,
        lineHeight: "140%",
        letterSpacing: 0
      }
    }
  },
  sm: {
    element: "span",
    styles: {
      primary: {
        fontSize: 16,
        lineHeight: "140%",
        letterSpacing: 0
      },
      secondary: {
        fontSize: 16,
        lineHeight: "140%",
        letterSpacing: 0
      }
    }
  },
  xs: {
    element: "span",
    styles: {
      primary: {
        fontSize: 14,
        lineHeight: "140%",
        letterSpacing: 0
      },
      secondary: {
        fontSize: 14,
        lineHeight: "140%",
        letterSpacing: 0
      }
    }
  },
  "2xs": {
    element: "span",
    styles: {
      primary: {
        fontSize: 12,
        lineHeight: "140%",
        letterSpacing: 0
      },
      secondary: {
        fontSize: 12,
        lineHeight: "140%",
        letterSpacing: 0
      }
    }
  },
  "3xs": {
    element: "span",
    styles: {
      primary: {
        fontSize: 10,
        lineHeight: "140%",
        letterSpacing: 0
      },
      secondary: {
        fontSize: 10,
        lineHeight: "140%",
        letterSpacing: 0
      }
    }
  }
};

const useStyles = makeStyles(theme => ({
  root: ({ variant = "md", isBold, font, color }) => {
    const baseStyles = {
      color: getObjectValueByString(theme.palette, color),
      fontFamily: isBold ? "iranyekanBold" : "iranyekan"
    };

    const variantStyles = variantMapping[variant].styles[font];

    return { ...baseStyles, ...variantStyles };
  }
}));

const Typography = React.forwardRef(
  (
    {
      children,
      variant = "xs",
      className,
      component,
      isBold,
      font,
      color,
      gutterBottom,
      noWrap,
      onClick
    },
    ref
  ) => {
    const classes = useStyles({ variant, isBold, font, color });

    return (
      <MuiTypography
        classes={classes}
        variantMapping={mapValues(variantMapping, function (obj) {
          return obj["element"];
        })}
        ref={ref}
        noWrap={noWrap}
        variant={variant}
        component={component}
        className={className}
        gutterBottom={gutterBottom}
        color={color}
        onClick={onClick}
      >
        {children}
      </MuiTypography>
    );
  }
);

Typography.defaultProps = {
  isBold: false,
  gutterBottom: false,
  component: null,
  className: "",
  font: "primary",
  color: "black"
};

export default Typography;
